export default __webpack_public_path__ + "static/media/nihal-ahmad.fc77b1c5.jpeg";